import { GenericResponse } from 'types/GenericResponse';
import { createAsyncAction } from 'utils/Redux';

const ns = 'CREATE_DEFAULT_WIDGET';

const asyncAction = createAsyncAction<GenericResponse>(ns);

const createDefaultFormWidgetAction = {
  ...asyncAction,
};

export default createDefaultFormWidgetAction;
